import EventStandingsSummary from "./EventStandingsSummary";
export default EventStandingsSummary;
